import * as React from 'react'
import RedirectPage from 'redirectPage'
import barcodesReportImage from 'images/barcodes-report.png'

const CHECKOUT_PERFORMANCE_TAB_NODE_ID = '-C18gFCPnl'

interface CheckoutFunnelReportPageProps {
    accountSlug: string
}

const CheckoutFunnelReportPage = ({ accountSlug }: CheckoutFunnelReportPageProps) => (
    <RedirectPage
        oldPageTitle="Checkout Funnel Report"
        newPageTitle="Marketing Report"
        action="is now part of"
        image={barcodesReportImage}
        link={`/account/${accountSlug}/reports/marketing#${CHECKOUT_PERFORMANCE_TAB_NODE_ID}`}
    />
)

export default CheckoutFunnelReportPage
